import React, { memo } from 'react';
import { Tab } from '../../constants';

const TabsContext: React.Context<Tab> = React.createContext(null);
TabsContext.displayName = 'TabsContext';

export const TabsProvider: React.FC<{
  value: Tab;
  children: React.ReactNode;
}> = memo(({ value, children }) => (
  <TabsContext.Provider value={value}>
    <>{children}</>
  </TabsContext.Provider>
));
export const TabsConsumer = TabsContext.Consumer;
export default TabsContext;
